/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('site.carousel', [
        'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
        'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
    ], function (el) {
        var selector = '#' + el.id + ' .swiper-container';
        if (selector.includes('property__images__big')) {
            Carousel.handlePropertyImages(selector);
        }
        else {
            console.log(selector);
        }
    });
    var Carousel = /** @class */ (function () {
        function Carousel() {
        }
        Carousel.handlePropertyImages = function (selector) {
            var swiperParams = {
                direction: 'horizontal',
                slidesPerView: 1,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                },
            };
            new swiper.Swiper(selector, swiperParams);
        };
        return Carousel;
    }());

}(window));
typeof tsBuild === 'function' && tsBuild();})();
